<template>
  <div class="handle">
    <!-- The bubble menu -->
    <div
      ref="menu"
      class="tippy-wrapper flex flex-row justify-center items-center"
    >
      <div
        v-if="editor"
        class="bubble-menu bg-white rounded-lg mb-1 p-1 flex flex-row justify-center shadow-lg"
      >
        <button
          class="menu"
          v-tooltip="'Bold'"
          @click="
            editor
              .chain()
              .selectAll()
              .toggleBold()
              .run()
          "
          :class="{ 'is-active': editor.isActive('bold') }"
        >
          <span class="material-icons">
            format_bold
          </span>
        </button>

        <button
          class="menu"
          v-tooltip="'Italic'"
          @click="
            editor
              .chain()
              .selectAll()
              .toggleItalic()
              .run()
          "
          :class="{ 'is-active': editor.isActive('italic') }"
        >
          <span class="material-icons">
            format_italic
          </span>
        </button>

        <div
          class="font__setter flex flex-row h-9 m-auto rounded"
          style="border: 1px solid rgba(57,76,96,.15);"
        >
          <div
            class="w-6 text-center cursor-pointer flex flex-row justify-center"
            @click="subtractFont"
            v-tooltip="'Increase Font'"
          >
            <svg-icon
              icon="heroicons/solid/minus"
              class=" w-4 h-4 p-0 m-auto text-gray-500 cursor-pointer "
            />
          </div>
          <input
            class="w-8 border-l border-r border-solid border-gray-200 text-center text-gray-600"
            v-model="fontSize"
            style="font-family: 'Roboto', san-serif"
            v-tooltip="'Font Size'"
          />
          <div
            class="w-6 text-center cursor-pointer flex flex-row justify-center"
            @click="addFont"
            v-tooltip="'Decrease Font'"
          >
            <svg-icon
              icon="heroicons/solid/plus"
              class=" w-4 h-4 p-0 m-auto text-gray-500 cursor-pointer "
            />
          </div>
        </div>

        <!-- Color Picker start -->
        <BasePopover :showPopover="colorSettings">
          <template v-slot:button>
            <button
              class="menu flex flex-col items-center justify-center relative border border-solid border-gray-300"
              style="padding:0px"
              v-tooltip="'Colors'"
              @click="colorSettings = true"
              :style="{
                'box-shadow': 'none',
              }"
            >
              <span class="material-icons" :style="{ color: bgColor }">
                palette
              </span>
            </button>
          </template>

          <template v-slot:body>
            <div
              id="button-settings"
              class=" bg-gray-800 rounded mt-2 z-10 inline-block text-left pl-3 pb-3"
              style="right: 0%;"
            >
              <div class="flex flex-row-reverse justify-between">
                <div @click="closecolorSettings">
                  <svg-icon
                    icon="heroicons/outline/x"
                    class="w-3 h-3 text-gray-400 hover:text-gray-300 font-bold mt-2 mr-2 cursor-pointer"
                  />
                </div>

                <div class="flex flex-row"> <input type="checkbox" id="checkbox" v-model="checked" class="my-auto"><label for="checkbox" class="text-xs text-white my-auto">Use theme defaults</label></div>

              </div>

              <div class="pr-3">
                <ul class="flex mb-0 list-none flex-wrap pt-0 pb-4 flex-row">
                  <li class="-mb-px pr-1 mr-2 last:mr-0 flex-auto text-center">
                    <a
                      class="text-xs font-bold uppercase py-1 block leading-normal hover:no-underline"
                      v-on:click="toggleTabs(1)"
                      v-bind:class="{
                        'text-gray-400 hover:text-gray-300 cursor-pointer':
                          openTab !== 1,
                        'text-gray-400 hover:text-gray-300 border-b-2 border-blue-500 cursor-pointer ':
                          openTab === 1,
                      }"
                    >
                      Background
                    </a>
                  </li>
                  <li class="-mb-px mr-2 pr-1 last:mr-0 flex-auto text-center">
                    <a
                      class="text-xs font-bold uppercase py-1 block leading-normal hover:no-underline"
                      v-on:click="toggleTabs(2)"
                      v-bind:class="{
                        'text-gray-400 hover:text-gray-300 cursor-pointer':
                          openTab !== 2,
                        'text-gray-400 hover:text-gray-300 border-b-2 border-blue-500 cursor-pointer ':
                          openTab === 2,
                      }"
                    >
                      Text
                    </a>
                  </li>

                  <li class="-mb-px mr-2 pr-1 last:mr-0 flex-auto text-center">
                    <a
                      class="text-xs font-bold uppercase py-1 block leading-normal hover:no-underline"
                      v-on:click="toggleTabs(3)"
                      v-bind:class="{
                        'text-gray-400 hover:text-gray-300 cursor-pointer':
                          openTab !== 3,
                        'text-gray-400 hover:text-gray-300 border-b-2 border-blue-500 cursor-pointer':
                          openTab === 3,
                      }"
                    >
                      Border
                    </a>
                  </li>
                </ul>

                <div v-if="openTab == 1" class="">
                  <verte
                    model="rgb"
                    v-model="bgColor"
                    display="widget"
                    :enableAlpha="true"
                    :showHistory="false"
                  >
                    <div
                      class="h-5 w-5 border border-solid border-white ml-2"
                      :style="{ background: bgColor }"
                    ></div>
                  </verte>
                </div>

                <div v-if="openTab == 2" class="">
                  <verte
                    model="rgb"
                    v-model="color"
                    display="widget"
                    :enableAlpha="false"
                    :showHistory="false"
                  >
                    <div
                      class="h-5 w-5 border border-solid border-white ml-2"
                      :style="{ background: color }"
                    ></div>
                  </verte>
                </div>

                <div v-if="openTab == 3" class="">
                  <verte
                    model="rgb"
                    v-model="borderColor"
                    display="widget"
                    :enableAlpha="true"
                    :showHistory="false"
                  >
                    <div
                      class="h-5 w-5 border border-solid border-white ml-2"
                      :style="{ background: borderColor }"
                    ></div>
                  </verte>
                </div>
              </div>
            </div>
          </template>
        </BasePopover>

        <BasePopover :showPopover="linkSettings" :placement="'bottom-end'">
          <template v-slot:button>
            <button
              class="menu"
              @click="linkSettings = true"
              v-tooltip="'Link'"
            >
              <span class="material-icons">
                open_in_new
              </span>
            </button>
          </template>

          <template v-slot:body>
            <div
              id="button-link"
              class="rounded-lg mt-3 z-10 bg-white border border-solid border-gray-300 inline-block text-left px-3 pb-3 shadow"
              style="right: 0%;"
            >
              <div class="flex flex-row-reverse">
                <div @click="linkSettings = false">
                  <svg-icon
                    icon="heroicons/outline/x"
                    class="w-3 h-3 text-gray-400 hover:text-gray-500 font-bold mt-2 -mr-1 cursor-pointer "
                  />
                </div>
              </div>

              <div class="pr-3">
                <label
                  for="goto"
                  class="block text-sm font-medium pb-2 text-gray-500"
                  >When the button is clicked go to:
                </label>
                <select
                  v-model="goto"
                  id="goto"
                  name="goto"
                  autocomplete="goto"
                  class="mt-1 block w-full py-2 px-3 bg-gray-100 focus:bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                >
                  <option value="next" class="italic font-bold">The next step </option>
                  <option value="prev" class="italic font-bold">The previous step</option>
            <option
              :key="index"
              v-for="(step, index) in survey.steps"
              :value="step.auto_id"
            >
              <span v-text="step.title || 'Step ' + (index+1)"> </span>
            </option>
                  <option value="link" class="italic font-bold">An External link </option>
                  <option value="close" class="italic font-bold">Close page and exit flow </option>
                </select>
              </div>

              <div v-show="goto == 'link'" class="col-span-3 sm:col-span-2">
                <label class="block text-sm font-medium text-gray-700 mt-3">
                  Link:
                </label>
                <div class="mt-1 flex rounded-md shadow-sm">
                  <input
                    type="text"
                    class="py-2 px-3 focus:ring-indigo-500 focus:border-indigo-500 flex-1 block w-full rounded-none rounded-md sm:text-sm border border-solid border-gray-300"
                    placeholder="http://www.example.com"
                    v-model="gotoLink"
                  />
                </div>
              </div>
            </div>
          </template>
        </BasePopover>

        <button
          class="menu"
          v-tooltip="'Clone Button'"
          @click="copyContent"
        >
          <span class="material-icons">
            content_copy
          </span>
        </button>

        <BasePopover :showPopover="showPaddingPopover">
          <template v-slot:button>
            <button
              class="menu flex flex-col items-center justify-center relative"
              @click="showPaddingPopover = true"
              :style="{ padding: '0px' }"
              v-tooltip="'More'"
            >
              <span class="material-icons">
                more_horiz
              </span>
            </button>
          </template>

          <template v-slot:body>
            <div
              id="button-settings"
              class="bg-white border border-solid border-gray-300 shadow-lg rounded mt-2 z-10 inline-block text-left pl-3 pb-1"
              style="right: 0%;"
            >
              <div class="flex flex-row-reverse">
                <div @click="showPaddingPopover = false">
                  <svg-icon
                    icon="heroicons/outline/x"
                    class="w-3 h-3 text-gray-400 hover:text-gray-300 font-bold mt-2 mr-2 cursor-pointer"
                  />
                </div>
              </div>

              <div
                class="pr-3 flex mb-0 list-none flex-wrap pt-0 pb-1 flex-row"
              >
                <table>
                  <tbody>
                    <tr>
                      <td class="pr-6 py-1"></td>
                      <td class="pr-5 py-1 text-center text-xs text-gray-600">
                        X-axis
                      </td>
                      <td class="py-1 text-center text-xs text-gray-600">
                        Y-axis
                      </td>
                    </tr>
                    <tr>
                      <td class="pr-3 py-1 text-xs">Padding</td>
                      <td class="pr-5 py-1">
                        <input
                          v-model="paddingX"
                          class="text-center w-8 h-8 rounded border border-solid border-gray-300"
                        />
                      </td>
                      <td class="py-1">
                        <input
                          v-model="paddingY"
                          class="text-center w-8 h-8 rounded border border-solid border-gray-300"
                        />
                      </td>
                    </tr>

                    <tr>
                      <td class="pr-3 py-1 text-xs">Border Radius</td>
                      <td class="pr-5 py-1">
                        <input
                          v-model="borderRadius"
                          class="text-center w-8 h-8 rounded border border-solid border-gray-300"
                        />
                      </td>

                      <td class="py-1"></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </template>
        </BasePopover>
      </div>

      <div class="outer__menu flex flex-row">

        <div @click="closeMenu" v-tooltip="'Close Menu'">
          <svg-icon
            icon="heroicons/outline/x"
            class="h-8 w-8 cursor-pointer p-1 text-gray-500 bg-gray-200 hover:bg-gray-300 rounded-full ml-2"
          />
        </div>

        <div @click="$emit('delete-content', model)">
          <svg-icon
            icon="heroicons/outline/trash"
            class="h-8 w-8 cursor-pointer p-1 text-gray-500 bg-gray-200 hover:bg-gray-300 rounded-full ml-2"
            v-tooltip="'Delete button'"
          />
        </div>

<!--
        <BasePopover :showPopover="showContentPopover">
          <template v-slot:button>
            <div @click="showContentPopover = true">
              <svg-icon
                icon="heroicons/outline/plus"
                class="h-8 w-8 cursor-pointer p-1 text-gray-500 bg-gray-200 hover:bg-gray-300 rounded-full ml-2"
                v-tooltip="'Add content to column'"
              />
            </div>
          </template>

          <template v-slot:body>
            <div
              id="button-settings"
              class="bg-white border border-solid border-gray-300 shadow-lg rounded mt-2 z-10 inline-block text-left pl-3 pb-1"
              style="right: 0%;"
            >
              <div class="flex flex-row-reverse">
                <div @click="showContentPopover = false">
                  <svg-icon
                    icon="heroicons/outline/x"
                    class="w-3 h-3 text-gray-400 hover:text-gray-300 font-bold mt-2 mr-2 cursor-pointer"
                  />
                </div>
              </div>

              <div
                class="pr-3 flex mb-0 list-none flex-wrap pt-0 pb-1 flex-row"
              >
                <div
                  class="border border-solid border-gray-200 cursor-pointer mr-5 bg-white rounded flex flex-col items-center hover:shadow-md"
                  @click="$emit('add-content', 'IMAGE')"
                >
                  <svg-icon
                    icon="heroicons/outline/photograph"
                    class="w-9 h-9 text-blue-400 p-1 rounded-full"
                  />
                </div>

                <div
                  class="border border-solid w-9 h-9 text-blue-400 border-gray-200 cursor-pointer mr-5 bg-white rounded flex flex-col items-center justify-center hover:shadow-md"
                  @click="$emit('add-content', 'TEXT')"
                >
                  <span class="material-icons">
                    title
                  </span>
                </div>

                <div
                  class="border border-solid text-blue-400 border-gray-200 cursor-pointer mr-5 bg-white rounded flex flex-col items-center hover:shadow-md"
                  @click="$emit('add-content', 'BUTTON')"
                >
                  <svg-icon
                    icon="misc/ok-button"
                    class="w-9 h-9 text-blue-400 p-1 rounded-full"
                  />
                </div>
              </div>
            </div>
          </template>
        </BasePopover>

-->

      </div>
    </div>

    <!-- The actual button starts here -->
    <div
      ref="target"
      class="content-button text-base hover:no-underline cursor-pointer inline-block border border-solid border-transparent"
      :style="{
        color: fontColor,
        'font-family': survey.fontFamily,
        'background-color': bgColor,
        'border-color': borderColor,
        'border-radius': borderRadius + 'px',
        padding: paddingY + 'px ' + paddingX + 'px',
      }"
    >

      <editor-content
        v-if="editMode"
        :editor="editor"
        :style="cssVars"
      />

      <div
        v-else
        @click="editMode = true"
        v-html="model.text"
        class="cursor-pointer ProseMirror"
        :style="cssVars"
      ></div>
      
    </div>
  </div>
</template>

<script>
import { Editor, EditorContent } from "@tiptap/vue-2";
import { defaultExtensions } from "@tiptap/starter-kit";
import Button from "@/models/content/Button";
import Text from "@/models/content/Text";
import tippy from "tippy.js";

//Verte Color Picker
//https://baianat.github.io/verte/guide/
import Verte from "verte";
//import "verte/dist/verte.css";

// Uses clickaway mixin from https://github.com/simplesmiler/vue-clickaway
import { mixin as clickaway } from "vue-clickaway";

export default {
    mixins: [clickaway],
  name: "button-content",
  components: {
    EditorContent,
    Verte,
  },
  data() {
    return {
      bubbleMenu: null,
      colorSettings: false,
      showPaddingPopover: false,
      showContentPopover: false,
      linkSettings: false,
      editor: null,
      editMode: false,
      openTab: 1,
      checked: true
    };
  },
  props: ["content_id", "survey", "step", "align", "dragging"],
  computed: {
    cssVars() {
      return {
        "--text-color": this.color,
        "--font-size": this.fontSize + "px",
        "--font-family": this.survey.fontFamily,
      };
    },

    model() {
      return Button.find(this.content_id);
    },

    color: {
      get() {
        return this.model.fontColor;
      },
      set(col) {
        Button.update({
          where: this.content_id,
          data: { fontColor: col },
        });
      },
    },

    fontSize: {
      get() {
        return this.model.fontSize;
      },
      set(num) {
        Button.update({
          where: this.content_id,
          data: { fontSize: num },
        });
      },
    },

    fontColor: {
      get() {
        return this.model.fontColor ?? this.survey.buttonFontColor;
      },
      set(value) {
        if (this.checked) {
          value = null;

        }
        Button.update({
            where: this.model.id,
            data: { fontColor: value },
        });

      },
    },

    bgColor: {
      get() {
        return this.model.bgColor ?? this.survey.buttonBgColor;
      },
      set(value) {
        if (this.checked) {
          value = null;

        }
        Button.update({
            where: this.model.id,
            data: { bgColor: value },
        });

      },
    },

    borderColor: {
      get() {
        return this.model.borderColor ?? this.survey.buttonBorderColor;
      },
      set(value) {
        if (this.checked) {
          value = null;

        }
        Button.update({
            where: this.model.id,
            data: { borderColor: value },
        });

      },
    },
    /*
    borderColor: {
      get() {
        return this.model.borderColor;
      },
      set(value) {
        if (value !== this.model.borderColor) {
          Button.update({
            where: this.model.id,
            data: { borderColor: value },
          });
        }
      },
    },
    */
    borderRadius: {
      get() {
        
        return Number.isInteger(this.model.borderRadius) ? this.model.borderRadius : null;
      },
      set(value) {
        if (isNaN(value)) value = null;
        if (value !== this.model.borderRadius) {
          Button.update({
            where: this.model.id,
            data: { borderRadius: value },
          });
        }
      },
    },
    paddingX: {
      get() {
        
        return Number.isInteger(this.model.paddingX) ? this.model.paddingX : null;
      },
      set(value) {
        if (isNaN(value)) value = null;
        if (value !== this.model.paddingX) {
          Button.update({
            where: this.model.id,
            data: { paddingX: value },
          });
        }
      },
    },
    paddingY: {
      get() {
        
        return Number.isInteger(this.model.paddingY) ? this.model.paddingY : null;
      },
      set(value) {
        if (isNaN(value)) value = null;
        if (value !== this.model.paddingY) {
          Button.update({
            where: this.model.id,
            data: { paddingY: value },
          });
        }
      },
    },
    goto: {
      get() {
        return this.model.goto;
      },
      set(value) {
        if (value !== this.model.goto) {
          Button.update({ where: this.model.id, data: { goto: value } });
        }
      },
    },
    gotoLink: {
      get() {
        return this.model.goto_link;
      },
      set(value) {
        if (value !== this.model.goto_link) {
          Button.update({ where: this.model.id, data: { goto_link: value } });
        }
      },
    },
  },
  methods: {
    toggleTabs: function(tabNumber) {
      this.openTab = tabNumber;
    },
    addFont() {
      this.fontSize++;
    },
    subtractFont() {
      this.fontSize--;
    },
    setAlign(dir) {
      this.$emit("set-align", dir);
    },
    addContent() {
      this.$emit("add-content");
    },
    deleteContent() {
      //await Button.delete(this.model.id);
      this.$emit("delete-content", this.model);
    },
    copyContent(){
      this.$emit("copy-content", this.model);
    },
    closeMenu(event) {
      //Close BubbleMenu created by Tippy.js directly (w/o editor)
      this.bubbleMenu.hide();
      //Disable editor
      this.editMode = false;
      this.closecolorSettings(event);
    },

    closecolorSettings(event) {
      //Close Button Setting dropdown
      event.stopPropagation();
      this.colorSettings = false;
    },
  },

  watch: {
    //disable editing upon drag; 'editable' value will be reset to true on next cursor focus
    dragging() {
      if (this.dragging == true) {
        this.editor.view.editable = false;
      }
    },

    checked() {
      if (this.checked == true) {
        
        this.bgColor = null;
        this.borderColor = null;
        this.fontColor = null;
      }
    },

  },

  mounted() {
    
    if (this.bgColor == null) this.checked = true;
    
    var self = this;

    this.editor = new Editor({
      extensions: [...defaultExtensions()],
      content: this.model.text,
      onUpdate() {
        const html = this.getHTML();
        Button.update({
          where: self.content_id,
          data: { text: html },
        });
      },
      autofocus: true,
      editorProps: {
        attributes: {
          class: `${this.content_id} prose prose-sm sm:prose lg:prose-lg xl:prose-2xl mx-auto focus:outline-none`,
        },
      },
    });

    let target = this.$refs.target; 
    let menu = this.$refs.menu; 

    this.bubbleMenu = tippy(target, {
      content: menu,
      interactive: true,
      duration: 10,
      maxWidth: "none",
      hideOnClick: false,
      trigger: "click",
      onClickOutside(instance, event) {
        instance.hide();
      },
    });
  },
};
</script>

<style></style>
